import { Link } from "react-router-dom";
import type { Movie } from "@/types/media";

export default function MovieListItem({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex gap-4 bg-background-50 rounded-lg border border-background-200 hover:border-primary-200 transition-colors p-3 cursor-pointer"
    >
      <div className="w-24 sm:w-28 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 剧情介绍`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0 py-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
            {movie.title}
          </h3>
          <span className="shrink-0 text-accent-600 font-label font-bold text-sm">
            {movie.rating.toFixed(1)}
          </span>
        </div>
        <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs md:text-sm text-foreground-500">
          <span>{movie.year}</span>
          <span>{movie.type}</span>
          <span>{movie.region}</span>
          <span>{movie.duration}</span>
        </div>
        <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {movie.summary}
        </p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {movie.genres.map((g) => (
            <span
              key={g}
              className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}